import useAsync from 'react-use/lib/useAsync';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import { sanitizeMarkdownContent } from './sanitizers';
import { getGitHubApiUrl, getGitHubHeaders, isAllowedGitHubUrl } from './gitHubHelpers';
import { getTitleFromPath } from './filenameParser';

export const useEntityMarkdown = () => {
  const scmAuthApi = useApi(scmAuthApiRef);
  const { entity } = useEntity();
  const annotationUrl = entity.metadata.annotations?.['equinor.com/entity-markdown-readme-url'];

  const {
    value,
    loading: asyncLoading,
    error,
  } = useAsync(async () => {
    if (!annotationUrl) {
      return undefined;
    }
    if (!isAllowedGitHubUrl(annotationUrl)) {
      throw new Error(
        'Only GitHub content from equinor or equinor-playground organizations is allowed.',
      );
    }

    const [fetchUrl, path] = getGitHubApiUrl(annotationUrl);
    const headers = await getGitHubHeaders(scmAuthApi, annotationUrl);
    const response = await fetch(fetchUrl, { headers });
    if (!response.ok)
      throw new Error(`Failed to fetch markdown: ${response.status} ${response.statusText}`);

    const markdown = await response.text();

    const title = getTitleFromPath(path) || 'Readme';

    return { markdown: sanitizeMarkdownContent(markdown), title: title };
  }, [annotationUrl]);

  const loading = annotationUrl ? asyncLoading : false;

  return { value, loading, error };
};
